import styled from "styled-components";

export const AdminBoxesSettingsDetailModalHeading = styled.div`
  margin-bottom: 1.5rem;
`;
